import Slider from "@ant-design/react-slick";
import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import ApplicationRow from "../header/ApplicationRow";
import "./ApplicationLine.css";
import EmployeRow from "./EmployeRow";

const ApplicationLine = ({ implementers, subdivision, goScroll, cancleScroll, slidesToShow }) => {

    const { isLoading } = useSelector((state) => state.ui);
    const sliderRef = useRef();

    const settings = {
        infinite: false,
        speed: 500,
        slidesToShow: slidesToShow || 1,
        slidesToScroll: slidesToShow || 1,
        arrows: false,
        vertical: true,
        verticalSwiping: true,
        waitForAnimate: false,
        focusOnSelect: true,
    };

    useEffect(() => {
        if (goScroll) {
            sliderRef.current.slickNext();
            cancleScroll()
        }
    }, [goScroll])


    useEffect(() => {
        sliderRef.current.slickGoTo(0, true);
    }, [implementers]);

    return (
        <>
            <div
                className="department_line"
                style={{ opacity: isLoading ? 0.6 : 1 }}
            >
                <Slider ref={sliderRef} {...settings}>
                    {implementers.map((implementer) => (
                        <EmployeRow
                            key={implementer.uuid}
                            name={implementer.name_rus}
                            planned={implementer.counts.planned}
                            working={implementer.counts.working}
                            paused={implementer.counts.paused}
                            finished={implementer.counts.finished}
                            cancled={implementer.counts.cancled}
                            apps={implementer.counts.apps}
                            total={implementer.total}
                        />
                    ))}
                </Slider>
            </div>

            <ApplicationRow
                lineSupport={subdivision.name}
                orangeText={"15-30 мин"}
                redText={"> 30 мин "}
                subdivisionUUID={subdivision.uuid}
                departmentUUID={subdivision.department_uuid}
            />
        </>
    );
};

export default ApplicationLine;
